import { render } from "./QVPExam.vue?vue&type=template&id=53b61157&scoped=true"
import script from "./QVPExam.vue?vue&type=script&lang=js"
export * from "./QVPExam.vue?vue&type=script&lang=js"

import "./QVPExam.vue?vue&type=style&index=0&id=53b61157&lang=css"
import "./QVPExam.vue?vue&type=style&index=1&id=53b61157&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b61157"]])

export default __exports__